var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGreen(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32.134,
    height: 27.624,
    viewBox: "0 0 32.134 27.624",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1014",
    "data-name": "Group 1014",
    transform: "translate(5.673 -1.682)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_978",
    "data-name": "Group 978",
    transform: "translate(-6.349 -5.551)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_977",
    "data-name": "Group 977",
    transform: "translate(4.705 6.499)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_973",
    "data-name": "Group 973",
    transform: "translate(-6.07 -5.306)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "plant"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_248",
    "data-name": "Group 248",
    transform: "translate(2.041 6.04)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_247",
    "data-name": "Group 247"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2911",
    "data-name": "Path 2911",
    d: "M10.9,24.22c-2.368-2.367-7-2.641-10.282-2.641A.616.616,0,0,0,0,22.194c0,3.28.273,7.914,2.641,10.282a5.731,5.731,0,0,0,4.05,1.446A6.138,6.138,0,0,0,10.9,32.475C12.661,30.711,12.985,26.306,10.9,24.22Zm-.87,7.386c-1.317,1.316-4.974,1.541-6.514,0C1.6,29.695,1.27,25.812,1.234,22.813c3,.036,6.881.367,8.793,2.278C11.568,26.632,11.343,30.29,10.027,31.606Z",
    transform: "translate(0 -21.579)",
    fill: "#595959"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_250",
    "data-name": "Group 250",
    transform: "translate(21.122 7.76)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_249",
    "data-name": "Group 249",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2912",
    "data-name": "Path 2912",
    d: "M268.263,63.776c-3.468,0-8.368.289-10.872,2.793-2.207,2.206-1.865,6.863,0,8.728a6.493,6.493,0,0,0,4.446,1.529,6.067,6.067,0,0,0,4.284-1.528c2.5-2.5,2.793-7.4,2.793-10.872A.651.651,0,0,0,268.263,63.776Zm-3.065,10.6c-1.629,1.629-5.5,1.391-6.888,0s-1.629-5.259,0-6.888c2.021-2.021,6.127-2.371,9.3-2.409C267.57,68.251,267.22,72.357,265.2,74.377Z",
    transform: "translate(-255.862 -63.776)",
    fill: "#595959"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_252",
    "data-name": "Group 252",
    transform: "translate(7.098 10.96)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_251",
    "data-name": "Group 251",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2913",
    "data-name": "Path 2913",
    d: "M105.071,110.2a.767.767,0,0,0-1-.314,17.007,17.007,0,0,0-9.331,11.607c-1.5-9.752-5.85-12.725-7.693-13.987a4.453,4.453,0,0,1-.508-.37.709.709,0,0,0-1,1,5.708,5.708,0,0,0,.711.538c2.078,1.421,7.6,5.2,7.6,20.246a.71.71,0,0,0,1.419,0c0-6.081,1.633-14.1,9.413-17.753,0,0,.115-.055.115-.055A.658.658,0,0,0,105.071,110.2Z",
    transform: "translate(-85.328 -106.928)",
    fill: "#595959"
  }))))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreen);
export default __webpack_public_path__ + "static/media/green.a372cdf0ffba3ddfd3672bc3234790a5.svg";
export { ForwardRef as ReactComponent };